import React, { FunctionComponent } from 'react';
import { IntlProvider } from 'react-intl';
import { CalculatorStudentLoanStepper } from './stepper';
import { CalculatorStudentLoanCta, CalculatorStudentLoanResult } from './';
import { useFormContext, useStepper } from '../../../../hooks';
import { CalculatorsStudentLoanResult } from '../../../../@types/features/calculators';
import useMediaQuery from '../../../../hooks/use-media';
import { mainMediaMobile } from '../../../../utils';
import { AppAlertDialog } from '../../../shared/general';
import { Box } from '@chakra-ui/react';

export const CalculatorStudentLoan: FunctionComponent = () => {
  const { result, hasError, setError, updateResult } =
    useFormContext<CalculatorsStudentLoanResult>();
  const { currentStep, setStepActive } = useStepper();
  const isMobile = useMediaQuery(mainMediaMobile);

  const handleOnClose = () => {
    updateResult(null);
    setError(false);
    setStepActive(0, true);
  };
  return (
    <IntlProvider locale={'nl'} defaultLocale={'nl'}>
      <div className={`grid grid-cols-12 p-4 md:p-0`}>
        {hasError && (
          <AppAlertDialog title={'let op!'} open={hasError} onClose={handleOnClose}>
            <Box>
              Door een technische storing kunnen we nu helaas geen berekening uitvoeren. Probeer het
              opnieuw.
            </Box>
          </AppAlertDialog>
        )}
        <div
          className={`col-span-12 md:col-span-5 ${
            currentStep ? (currentStep > 0 && isMobile ? 'mb-8' : '') : ''
          }`}>
          <CalculatorStudentLoanCta></CalculatorStudentLoanCta>
        </div>
        <div className={`col-span-12 md:col-span-7`}>
          <div hidden={!!result}>
            <CalculatorStudentLoanStepper></CalculatorStudentLoanStepper>
          </div>
          {result && <CalculatorStudentLoanResult></CalculatorStudentLoanResult>}
        </div>
      </div>
    </IntlProvider>
  );
};
